import { Instagram, Mail, Phone, Youtube } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { LOGO_URL } from "@/components/Header";

const TikTokIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

export default function Footer() {
  const { t } = useLang();
  const socials = [
    { href: "https://wa.me/6285117711353", icon: Phone, label: "WhatsApp 0851-1771-1353", id: "whatsapp" },
    { href: "mailto:alibtisam.kudus@gmail.com", icon: Mail, label: "alibtisam.kudus@gmail.com", id: "email" },
    { href: "https://www.instagram.com/al.ibtisam_pusat/", icon: Instagram, label: "Instagram", id: "instagram" },
    { href: "https://www.youtube.com/@alibtisam_pusat", icon: Youtube, label: "YouTube", id: "youtube" },
    { href: "https://www.tiktok.com/@al.ibtisam_pusat", icon: TikTokIcon, label: "TikTok", id: "tiktok" },
  ];
  const links = [
    { to: "/alumni", key: "nav.alumni" },
    { to: "/galeri", key: "nav.galeri" },
    { to: "/ppdb", key: "nav.ppdb" },
    { to: "/galang-dana", key: "nav.galang_dana" },
    { to: "/program", key: "nav.program" },
    { to: "/artikel", key: "nav.artikel" },
  ];

  return (
    <footer className="bg-emerald-950 text-emerald-50 arabesque" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <img src={LOGO_URL} alt="Al Ibtisam" className="h-24 w-auto bg-white rounded-md p-2 mb-4" />
          <p className="text-sm text-emerald-100/80 leading-relaxed">{t("footer.about")}</p>
        </div>
        <div>
          <h4 className="font-display text-xl font-semibold text-[#D4AF37] mb-4">{t("footer.links")}</h4>
          <ul className="space-y-2">
            {links.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-emerald-100/80 hover:text-[#D4AF37] transition-colors" data-testid={`footer-link-${l.key.split(".")[1]}`}>
                  {t(l.key)}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-display text-xl font-semibold text-[#D4AF37] mb-4">{t("footer.secretariat")}</h4>
          <p className="text-sm text-emerald-100/80 leading-relaxed" data-testid="footer-address">
            Komplek Madrasah NU Ibtidaul Falah<br />
            Jl. Raya Dawe-Gebog Dk. Gringging,<br />
            Ds. Samirejo, Kec. Dawe, Kab. Kudus<br />
            Kode Pos: 59353
          </p>
        </div>
        <div>
          <h4 className="font-display text-xl font-semibold text-[#D4AF37] mb-4">{t("footer.connect")}</h4>
          <div className="flex flex-wrap gap-3">
            {socials.map((s) => (
              <a
                key={s.id}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                data-testid={`social-${s.id}`}
                className="h-10 w-10 rounded-full border border-emerald-400/30 flex items-center justify-center text-emerald-100 hover:bg-[#D4AF37] hover:text-emerald-950 hover:border-[#D4AF37] transition-colors duration-200"
              >
                <s.icon className="h-4.5 w-4.5 h-5 w-5" />
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-emerald-400/20 py-5 text-center text-xs text-emerald-100/60">
        © {new Date().getFullYear()} Al Ibtisam — Alumni Ibtidaul Falah Samirejo. {t("footer.rights")}
      </div>
    </footer>
  );
}
